import { updatesData } from '@/mocks/home';

const tagClassMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-800',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            最新动态
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto">
            黑料爆料平台动态与重点事件跟进。不错过任何一个爆料的最新进展。
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-4 md:left-5 top-0 bottom-0 w-px bg-background-200/70"></div>

          <div className="space-y-6 md:space-y-8">
            {updatesData.map((item) => (
              <div key={item.id} className="relative pl-10 md:pl-12">
                <div className="absolute left-2 md:left-3 top-1 w-4 h-4 md:w-5 md:h-5 rounded-full border-2 border-primary-300 bg-background-50"></div>

                <div className="bg-background-50 border border-background-200/70 rounded-xl p-4 md:p-5">
                  <div className="flex items-center gap-2 mb-2 flex-wrap">
                    <span className="text-xs font-medium text-foreground-400">{item.date}</span>
                    {item.tag && (
                      <span
                        className={`px-1.5 py-0.5 rounded text-[10px] font-semibold whitespace-nowrap ${
                          tagClassMap[item.tagType] || 'bg-secondary-100 text-secondary-700'
                        }`}
                      >
                        {item.tag}
                      </span>
                    )}
                  </div>
                  <h3 className="font-heading text-sm md:text-base font-bold text-foreground-950 mb-2">
                    {item.title}
                  </h3>
                  <p className="text-foreground-500 text-xs md:text-sm leading-relaxed">
                    {item.summary}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}